<template>
  <!-- div class="rightbox">
    <div class="imgContainer" -->
      <div>
      <img class="centerRight" :src="getTrialProbe" />
      <img class="center" src="../assets/optimal_fixation.png"/>
    </div>
    <!-- /div>
  </div -->
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import * as Mousetrap from 'mousetrap'
import * as _ from 'lodash'
import State from '../mixins/State'
export default {
  mixins: [State],
  data: () => {
    return {
      timer: undefined,
      keyCode: undefined,
      start_time: undefined,
      response_time: null,
      end_time: undefined
    }
  },
  computed: {
    ...mapGetters(['getTrialProbe']),
    ...mapState({
      probe_duration: state => state.parameters.probe_duration,
      probe_fixation_duration: state => state.parameters.probe_fixation_duration
    })
  },
  mounted () {
    this.start_time = Date.now()
    // binds a handler to the left and right keys
    Mousetrap.bind(
      ['left', 'right', 'up'],
      _.once(e => {
        // record the response and reaction time + fixation duration following
        this.keyCode = e.keyCode
        this.response_time = Date.now() - this.start_time
        this.$router.replace('/outcome')
      })
    )
    // create a timer to navigate to the outcome state
    this.timer = setTimeout(() => {
      this.$router.replace('/focus/probe')
    }, this.probe_duration)
  },
  beforeDestroy () {
    // clear timeout
    clearTimeout(this.timer)
    // remove handlers for the left and right keys
    Mousetrap.unbind(['left', 'right', 'up'])
    this.end_time = Date.now()
    const remaining_time =
      this.response_time === null
        ? 0
        : this.probe_duration -
          this.response_time +
          this.probe_fixation_duration


    this.response({
      r: this.keyCode,
      remaining_time: remaining_time,
      start_time: this.start_time,
      response_time: this.response_time,
      end_time: this.end_time,
      response_state: 'probe'
    })

  // in order to provide more uniform data, we add a nulled probe_focus response
  // if participant responded during this state. Doing it here allows us to not enter
  // a focus state proper for a probe.
  /*
  if (typeof this.keyCode !== "undefined"){
    console.log(`Heres one: ${this.keyCode}`)
    this.response({
      r: null,
      remaining_time: null,
      start_time: null,
      response_time: null,
      end_time: null,
      response_state: 'probe_focus'
    })
  }
  */

},
  methods: {
    ...mapActions(['response'])
  }
}
</script>
